import test3 from './test3'
import prod from './prod'
import local from './local'


const envMap: Record<string, any> = {
  test3,
  prod,
  dev: local,
  local
}

type IEnv = keyof typeof envMap;

const getEnvFromUrl = (host = window.location.host) => {
  const env = host.split('-')[0];
  console.log('getEnvFromUrl', env)

  if (env in envMap) {
    return env as IEnv;
  }
};

export const env = getEnvFromUrl() || 'prod';
export const envConfig = envMap[env];
